import { render, staticRenderFns } from "./BucketDestination.vue?vue&type=template&id=50fecdbc&"
import script from "./BucketDestination.vue?vue&type=script&lang=js&"
export * from "./BucketDestination.vue?vue&type=script&lang=js&"
import style0 from "./BucketDestination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports